/* eslint-disable */
import wizardService from '@/services/wizard.service'

const state = {
    changed: false,
    guid: null,
    filterParams: [],
    directions: [],
    hotels: {},
    filteredHotels: null,
    prices: {},
    meals: [],
    hotelsTypes: [],
    hotelsStars: [],
    dropdownHotels: [],
    breadcrumbs: [],
    roomsWithOpenCancelRules: [],
    adultCount: 2,
    childs: [],

    loading: false
}

const getters = {
    isEmptyHotels: state => {
        return !Object.keys(state.hotels).length;
    },
    isCancelRuleOpen: (state) => ({ hotelId, roomId, mealId, htplaceId }) => {
        const roomKey = `${hotelId}_${roomId}_${mealId}_${htplaceId}`;
        return state.roomsWithOpenCancelRules.includes(roomKey);
    }
}

const mutations = {
    setChanged(state, changed = false) {
        state.changed = changed;
    },
    setGuid(state, guid = null) {
        state.guid = guid;
    },
    setFilterParams(state, filterParams = []) {
        state.filterParams = filterParams;
    },
    toggleCancelRule(state, room) {
        const hotel = state.hotels.find(h => h.main.hotel_id == room.hotel_id);
        const foundRoom = hotel.rooms.find(r =>
            r.room_id == room.room_id &&
            r.meal_id == room.meal_id &&
            r.htplace_id == room.htplace_id
        );
        if (foundRoom) {
            foundRoom.showCancelRule = !foundRoom.showCancelRule;
        }
    },
    setDirections(state, directions = []) {
        state.directions = directions;
    },
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },
    setPrices(state, prices = {}) {
        state.prices = prices;
    },
    setHotelsTypes(state, types = []) {
        state.hotelsTypes = types;
    },
    setHotelsStars(state, stars = []) {
        state.hotelsStars = stars;
    },
    setDropdownHotels(state, dropdownHotels = []) {
        state.dropdownHotels = dropdownHotels;
    },
    setMeals(state, meals = []) {
        state.meals = meals;
    },
    setBreadcrumbs(state, breadcrumbs = []) {
        state.breadcrumbs = breadcrumbs;
    },
    setFilteredHotels(state, hotels = []) {
        state.filteredHotels = hotels;
    },
    setLoadind(state, loading = false) {
        state.loading = loading;
    },
    setAdultCount(state, adultCount = 2) {
        state.adultCount = adultCount;
    },
    setChilds(state, childs = []) {
        state.childs = childs;
    },
}

const actions = {
    setAdultCount({ commit }, adultCount = 2) {
        commit('setAdultCount', adultCount);
    },
    setChilds({ commit }, childs = []) {
        commit('setChilds', [...childs]);
    },
    clearResult ({ commit }) {
        commit('setHotels', []);
    },
    getDirections ({ commit }) {
        wizardService.getDirections().then(response => {
            commit('setDirections', response);
        })
    },
    resetFilter({ commit }) {
        commit('setGuid', null);
        commit('setFilterParams', []);
        commit('setHotels', []);
        commit('setFilteredHotels', null);
        commit('setPrices', []);
        commit('setMeals', []);
        commit('setHotelsTypes', []);
        commit('setHotelsStars', []);
        commit('setDropdownHotels', []);
        commit('setLoadind', false);
    },
    getHotels ({ commit }, params) {
        commit('setFilteredHotels', null);
        commit('setLoadind', true);
        commit('setChanged', false)
        wizardService.getHotels(params).then(response => {
            commit('setGuid', response.guid);
            commit('setFilterParams', response.filter_params);
            commit('setHotels', response.hotels);
            commit('setPrices', response.prices);
            commit('setMeals', response.meal_dropdown);
            commit('setHotelsTypes', response.hotel_types_dropdowns);
            commit('setHotelsStars', response.star_dropdown);
            commit('setDropdownHotels', response.hotel_name_dropdown);
            commit('setLoadind', false);
        }).catch(() => {
            commit('setLoadind', false);
        })
    },
    filterInSidebar({state, commit}, params){
        const result = [];
        const hotels = state.hotels;
        commit('setFilteredHotels', null);

        hotels.forEach(hotel => {
            let isType = false;
            if(params.types.length){
                params.types.forEach(type => {
                    console.log(hotel.main.hoteltypes_all, type)
                    if(hotel.main.hoteltypes_all.indexOf(parseInt(type)) !== -1)
                        isType = true;
                });
            }else{
                isType = true;
            }

            let isStar = false
            if(params.stars.length){
                const star = parseInt(hotel.main.star);
                params.stars.forEach(item => {
                    if(star == item)
                        isStar = true;
                })
            }else{
                isStar = true;
            }

            let isHotel = false
            if(params.hotels.length){
                const hotelId = parseInt(hotel.main.hotel_id);
                params.hotels.forEach(item => {
                    if(hotelId == item)
                        isHotel = true;
                })
            }else{
                isHotel = true;
            }

            let isMeal = false
            if(params.meals.length){
                hotel.rooms.forEach(room => {
                    params.meals.forEach(item => {
                        if(room.meal_id == item)
                            isMeal = true;
                    })
                });
            }else{
                isMeal = true;
            }

            let isPrice = false
            if(params.prices.length == 2){
                const minPrice = parseInt(hotel.main.minprice);
                if((minPrice >= params.prices[0] && minPrice <= params.prices[1]))
                    isPrice = true;
            }

            if(isType && isStar && isHotel && isMeal && isPrice)
                result.push(hotel.main.hotel_id);
        });

        commit('setFilteredHotels', result);
    },
    setBreadcrumbs({ commit }, breadcrumbs)
    {
        commit('setBreadcrumbs', breadcrumbs);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
